import { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { RiEyeFill, RiEyeCloseFill } from "react-icons/ri";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import instance from "../../services/endpoint";

const ResetPassword = () => {
  const { resetToken } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();

  const validatePassword = (password) => {
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;
    if (!password) {
      return "Password is required.";
    } else if (!passwordRegex.test(password)) {
      return "Password must include one uppercase letter, one special symbol, one number, and be 8-20 characters long.";
    }
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const error = validatePassword(newPassword);
    if (error) {
      setPasswordError(error);
      return;
    }

    setLoading(true);
    setPasswordError("");

    try {
      await instance.post(`/api/v1/auth/resetpassword/${resetToken}`, {
        newPassword,
      });
      toast.success("Your password has been successfully reset.");
      setNewPassword("");
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = "Reset Password | Bitstek Advisory";
  }, []);

  return (
    <Container
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh", padding: "20px" }}>
      <Row className="w-100">
        <Col
          xs={12}
          md={8}
          lg={6}
          className="mx-auto shadow p-4 rounded bg-white">
          <h2 className="text-center mb-4 text-primary">Reset Password</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group
              controlId="newPassword"
              className="mb-3"
              style={{ position: "relative" }}>
              <Form.Label className="fw-bold">New Password</Form.Label>
              <div style={{ position: "relative" }}>
                <Form.Control
                  type={showNewPassword ? "text" : "password"}
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    setPasswordError(validatePassword(e.target.value));
                  }}
                  required
                  className="p-2 pe-5"
                />
                <span
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  style={{
                    position: "absolute",
                    right: "18px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "1.5rem",
                    color: "#D4AF37",
                    zIndex: 2,
                  }}>
                  {showNewPassword ? <RiEyeFill /> : <RiEyeCloseFill />}
                </span>
              </div>
              {passwordError && (
                <div className="text-danger mt-1">
                  <small>{passwordError}</small>
                </div>
              )}
            </Form.Group>

            <div className="text-center mt-4">
              <Button
                type="submit"
                disabled={loading}
                className="search-btn w-100">
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Reset Password"
                )}
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default ResetPassword;
